<template>
    <div class="dyn-page" :class="theme">
        <!-- 花瓣层（红玫瑰主题） -->
        <div class="petals" v-if="theme === 'rose'">
            <span v-for="n in 18" :key="n" :style="petalStyle(n)"></span>
        </div>

        <!-- 加载中 -->
        <div class="dyn-state" v-if="loading">
            <div class="state-ico">✉</div>
            <div class="state-text">正在拆信…</div>
        </div>

        <!-- 出错 / 不存在 -->
        <div class="dyn-state" v-else-if="error">
            <div class="state-ico">✉</div>
            <div class="state-text">{{ error }}</div>
            <div class="state-btn" @click="goList">回到信箱</div>
        </div>

        <!-- 内容 -->
        <template v-else>
            <div class="dyn-card">
                <header class="dyn-head">
                    <div class="head-orn">{{ theme === 'rose' ? '❀' : '✿' }}</div>
                    <div class="dyn-name" v-if="page.nameText">{{ page.nameText }}</div>
                    <h1 class="dyn-title">{{ page.title }}</h1>
                    <div class="dyn-sub" v-if="page.subtitle">{{ page.subtitle }}</div>
                    <div class="dyn-date" v-if="page.date">{{ page.date }}</div>
                </header>

                <!-- 诗句 -->
                <div class="dyn-verses" v-if="verses.length">
                    <p class="dyn-verse" v-for="(v, i) in verses" :key="'v' + i">{{ v }}</p>
                    <p class="dyn-from" v-if="page.verseFrom">—— {{ page.verseFrom }}</p>
                </div>

                <!-- 正文 -->
                <div class="dyn-body">
                    <p
                        class="dyn-p"
                        v-for="(p, i) in paragraphs"
                        :key="'p' + i"
                        :style="{ animationDelay: 0.15 + i * 0.1 + 's' }"
                    >{{ p }}</p>
                </div>

                <div class="dyn-divider" v-if="page.sign || page.signDate"><span>❦</span></div>

                <footer class="dyn-sign">
                    <span class="sign-name" v-if="page.sign">{{ page.sign }}</span>
                    <span class="sign-date" v-if="page.signDate">——{{ page.signDate }}</span>
                </footer>
            </div>

            <div class="dyn-back" @click="goList">
                <span class="back-ico">‹</span> 返回信箱
            </div>
        </template>
    </div>
</template>

<script>
import { publicApi } from '../admin/api';

export default {
    name: 'WeDynamicPage',
    data() {
        return {
            loading: true,
            error: '',
            page: {
                code: '',
                title: '',
                subtitle: '',
                nameText: '',
                theme: 'letter',
                verses: [],
                verseFrom: '',
                paragraphs: [],
                sign: '',
                signDate: '',
                date: ''
            }
        };
    },
    computed: {
        theme() {
            return this.page.theme || 'letter';
        },
        verses() {
            return (this.page.verses || []).filter(v => v && v.trim());
        },
        paragraphs() {
            return (this.page.paragraphs || []).filter(p => p && p.trim());
        }
    },
    watch: {
        // 同一路由切换 code（例如从列表连续点两封）时重新拉取
        '$route.params.code'() {
            this.fetch();
        }
    },
    created() {
        this.fetch();
    },
    methods: {
        fetch() {
            const code = this.$route.params.code;
            if (!code) {
                this.loading = false;
                this.error = '没有指定要打开的信';
                return;
            }
            this.loading = true;
            this.error = '';
            publicApi
                .page(code)
                .then(data => {
                    if (!data) {
                        this.error = '这封信不存在或已下线';
                        return;
                    }
                    this.page = data;
                    document.title = data.title || '信';
                })
                .catch(err => {
                    this.error = err.message || '这封信暂时打不开';
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        petalStyle(n) {
            const left = (n * 41) % 100;
            const delay = ((n * 17) % 70) / 10;
            const dur = 7 + ((n * 11) % 6);
            const size = 12 + ((n * 5) % 14);
            return {
                left: left + '%',
                width: size + 'px',
                height: size * 1.5 + 'px',
                animationDelay: delay + 's',
                animationDuration: dur + 's'
            };
        },
        goList() {
            this.$router.push('/forzl');
        }
    }
};
</script>

<style lang="less" scoped>
.dyn-page {
    position: relative;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 40px 30px 60px;
    background: linear-gradient(180deg, #fdf3e7 0%, #f9ead8 45%, #f5e2cc 100%);
    overflow: hidden;
}

/* ---------- 加载 / 出错 ---------- */
.dyn-state {
    position: relative;
    z-index: 2;
    padding-top: 220px;
    text-align: center;
    .state-ico {
        font-size: 64px;
        color: #d8a48f;
        margin-bottom: 24px;
    }
    .state-text {
        font-size: 28px;
        color: #9b7a5c;
        line-height: 1.7;
        padding: 0 20px;
    }
    .state-btn {
        display: inline-block;
        margin-top: 40px;
        padding: 16px 44px;
        font-size: 26px;
        color: #9b7a5c;
        background: rgba(255, 255, 255, 0.8);
        border: 1px solid rgba(176, 141, 110, 0.4);
        border-radius: 999px;
    }
}

/* ---------- 卡片 ---------- */
.dyn-card {
    position: relative;
    z-index: 3;
    max-width: 640px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.94);
    border: 1px solid rgba(176, 141, 110, 0.25);
    border-radius: 16px;
    box-shadow: 0 8px 30px rgba(150, 110, 70, 0.14);
    padding: 50px 36px 44px;
}

.dyn-head {
    text-align: center;
    margin-bottom: 36px;
}
.head-orn {
    font-size: 30px;
    color: #d8a48f;
    margin-bottom: 16px;
}
.dyn-name {
    font-size: 34px;
    font-weight: 600;
    letter-spacing: 12px;
    color: #a3122e;
    margin-bottom: 18px;
}
.dyn-title {
    margin: 0;
    font-size: 40px;
    font-weight: 600;
    color: #5b4636;
    line-height: 1.5;
    letter-spacing: 1px;
}
.dyn-sub {
    margin-top: 16px;
    font-size: 26px;
    color: #b08d6e;
    line-height: 1.6;
}
.dyn-date {
    display: inline-block;
    margin-top: 20px;
    font-size: 24px;
    color: #b08d6e;
    background: rgba(176, 141, 110, 0.12);
    padding: 6px 24px;
    border-radius: 999px;
}

/* ---------- 诗句 ---------- */
.dyn-verses {
    margin: 6px 0 30px;
    text-align: center;
}
.dyn-verse {
    margin: 0 0 14px;
    font-family: 'STKaiti', 'KaiTi', '楷体', serif;
    font-size: 34px;
    line-height: 1.9;
    color: #8a2540;
    letter-spacing: 2px;
}
.dyn-from {
    margin: 14px 0 0;
    font-size: 24px;
    color: #b08d6e;
}

/* ---------- 正文 ---------- */
.dyn-p {
    margin: 0 0 28px;
    font-size: 30px;
    line-height: 1.9;
    color: #4a3f35;
    text-align: justify;
    text-indent: 2em;
    word-break: break-all;
    opacity: 0;
    animation: dynPIn 0.6s ease forwards;
}
@keyframes dynPIn {
    from {
        opacity: 0;
        transform: translateY(14px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ---------- 分隔 / 落款 ---------- */
.dyn-divider {
    display: flex;
    align-items: center;
    margin: 46px 0 30px;
    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(176, 141, 110, 0.5));
    }
    &::after {
        background: linear-gradient(90deg, rgba(176, 141, 110, 0.5), transparent);
    }
    span {
        padding: 0 24px;
        font-size: 28px;
        color: #c69c7b;
    }
}
.dyn-sign {
    text-align: right;
    .sign-name {
        display: block;
        font-family: 'STKaiti', 'KaiTi', '楷体', serif;
        font-size: 34px;
        color: #7a5c44;
        letter-spacing: 2px;
    }
    .sign-date {
        display: block;
        margin-top: 12px;
        font-size: 26px;
        color: #a08a76;
    }
}

/* ---------- 返回 ---------- */
.dyn-back {
    position: relative;
    z-index: 3;
    max-width: 640px;
    margin: 36px auto 0;
    text-align: center;
    font-size: 28px;
    color: #9b7a5c;
    background: rgba(255, 255, 255, 0.78);
    border: 1px solid rgba(176, 141, 110, 0.35);
    border-radius: 999px;
    padding: 16px 0;
    .back-ico {
        font-size: 32px;
        margin-right: 8px;
        vertical-align: -2px;
    }
    &:active {
        background: rgba(255, 255, 255, 1);
    }
}

/* ================= 红玫瑰主题 ================= */
.dyn-page.rose {
    background: linear-gradient(180deg, #3d0a17 0%, #6b0f28 45%, #8c1130 100%);

    .dyn-card {
        background: rgba(74, 13, 28, 0.72);
        border: 1px solid rgba(255, 160, 185, 0.28);
        box-shadow: 0 10px 34px rgba(0, 0, 0, 0.35);
        backdrop-filter: blur(2px);
    }
    .dyn-name {
        color: #ff9db3;
    }
    .dyn-title {
        color: #ffe6ec;
    }
    .dyn-sub,
    .dyn-date,
    .dyn-from {
        color: #e0a3b3;
    }
    .dyn-date {
        background: rgba(255, 255, 255, 0.12);
    }
    .dyn-verse {
        color: #ffd9e2;
    }
    .dyn-p {
        color: #f6dde3;
    }
    .dyn-divider span {
        color: #ffb3c4;
    }
    .dyn-divider::before {
        background: linear-gradient(90deg, transparent, rgba(255, 180, 200, 0.5));
    }
    .dyn-divider::after {
        background: linear-gradient(90deg, rgba(255, 180, 200, 0.5), transparent);
    }
    .dyn-sign .sign-name {
        color: #ffc9d6;
    }
    .dyn-sign .sign-date {
        color: #e0a3b3;
    }
    .dyn-back {
        color: #ffc9d6;
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 180, 200, 0.35);
    }
}

/* ================= 简约主题 ================= */
.dyn-page.plain {
    background: #fff;
    .dyn-card {
        background: #fff;
        border-color: #ececec;
        box-shadow: none;
    }
    .dyn-title {
        color: #1f1f1f;
    }
    .dyn-name {
        color: #333;
    }
    .dyn-p {
        color: #444;
    }
    .dyn-verse {
        color: #333;
    }
}

/* ================= 花瓣 ================= */
.petals {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    pointer-events: none;
    span {
        position: absolute;
        top: -40px;
        display: block;
        background: radial-gradient(circle at 50% 30%, #ff6b86, #c01033 70%);
        border-radius: 50% 50% 50% 0;
        opacity: 0.8;
        animation-name: petalFall;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }
}
@keyframes petalFall {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 0;
    }
    12% {
        opacity: 0.85;
    }
    100% {
        transform: translateY(1400px) rotate(460deg);
        opacity: 0.1;
    }
}
</style>
